import { useCanAccess, useGetIdentity } from "ra-core";
import type { ReactNode } from "react";
import { Navigate } from "react-router";
import { OwnerDashboard } from "./OwnerDashboard";
import { useIsMobile } from "@/hooks/use-mobile";

// The dashboard needs the dashboard permission. Without it, people working
// leads land on the pipeline, the admin on the team page.
export const HomeGate = ({ children }: { children: ReactNode }) => {
  const { canAccess, isPending } = useCanAccess({
    resource: "dashboard",
    action: "list",
  });
  const { identity } = useGetIdentity();
  const isMobile = useIsMobile();
  if (isPending || !identity) return null;
  if (!canAccess) {
    const worksLeads = identity.permissions?.some((p: string) =>
      p.startsWith("leads."),
    );
    return (
      <Navigate
        // On the phone a manager starts the day from "Сьогодні"
        to={worksLeads ? (isMobile ? "/today" : "/funnel") : "/sales"}
      />
    );
  }
  return children;
};

export const Dashboard = () => (
  <HomeGate>
    <OwnerDashboard />
  </HomeGate>
);
